"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A convenience method to test if a passed prop has been defined.
 * @param {*} prop A property to test.
 * @return {boolean} True if the passed prop is defined.
 */
exports.isDefined = function (prop) {
    return typeof prop !== "undefined" && prop !== "undefined";
};
/**
 * A convenience method to test if a passed property is a blank string.
 * @param {*} prop A property to test.
 * @return {boolean} True if the passed prop is in fact a blank string.
 */
exports.isBlank = function (prop) { return !exports.isNotBlank(prop); };
/**
 * A convenience method to test if a passed property is a non blank string.
 * @param {*} prop A property to test.
 * @return {boolean} True if the passed prop is in fact a non blank string.
 */
exports.isNotBlank = function (prop) {
    return exports.isDefined(prop) && typeof prop === "string" && prop !== "";
};
